import React from 'react'
import { Modal } from 'react-bootstrap'
import "./discountMismatchModal.scss"
import Button from '../Button/Button';

interface NotificationModalProps {
  show: boolean;
  notificationHide: () => void;
  notificationtitle?: string;
  notificationtext?: string;
  submitButtonText?: string;
  cancelButtonText?: string;
  notificationOk: () => void;
  email?: string;
  couponCode?: string;
}

const NotificationModal: React.FC<NotificationModalProps> = ({ notificationHide, notificationOk, ...props }) => {
  return (
    <Modal
      {...props}
      aria-labelledby="notification-modal"
      centered
      // size=""
      onHide={notificationHide}
      className='notification-modal'
    >
      <Modal.Body>
        <div className='discountmismatch-wrapper'>
          <h3 className='discountmismatch-title'>Discount Code Mismatch</h3>
          <p className='discountmismatch-description'>
            The code <span>{props.couponCode}</span> is linked to another email address.
          </p>
          <p className='mt-3 discountmismatch-description mb-2'>To proceed, please choose an action:</p>
        </div>
        <div className='discountmismatch-btn-box'>
          <div className="row gx-2">
            <div className="col-12">
              <button className="btn mismatch-button w-100 d-flex align-items-center justify-content-between " onClick={() => { notificationOk() }}>
                <div>
                  <span className="d-block fw-semibold">Proceed without discount</span>
                  <span className="d-block small text-muted">Continue with <span className="fw-medium">{props.email}</span></span>
                </div>
                <i className="fas fa-arrow-right ms-2 text-muted"></i>
              </button>
            </div>
            <div className="col-12 mt-2">

              <button className="btn mismatch-button w-100 d-flex align-items-center justify-content-between " onClick={() => notificationHide()}>
                <div>
                  <span className="d-block fw-semibold">Use linked email address</span>
                  <span className="d-block small text-muted">Switch to account to claim the offer</span>
                </div>
                <i className="fas fa-sync ms-2 text-muted"></i>
              </button>
              {/* <Button btnText={props.submitButtonText || 'Delete'} onClick={() => notificationOk()} /> */}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default NotificationModal